var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixeledBoxPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 70,
    viewBox: "0 0 508 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7338 0H481.664V7.16512H488.172V17.401H501.191V26.6133H507.699V42.9907H501.191V52.203H488.172V61.4153H481.664V69.604H24.7338V61.4153H19.5269V52.203H6.50888V42.9907H0V26.6133H6.50888V17.401H19.5268V7.16512H24.7338V0Z",
    fill: "#795796"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixeledBoxPurple);
export default __webpack_public_path__ + "static/media/pixeled-box-purple.59e3959ff25cb7ad88c6f98cc46e092b.svg";
export { ForwardRef as ReactComponent };